// extracted by mini-css-extract-plugin
module.exports = {"root":"DialogContent_root__3XgQ4"};